import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AvailabilityEntity } from 'app/interfaces';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-avaliability-operator',
  templateUrl: './avaliability-operator.component.html',
  styleUrls: ['./avaliability-operator.component.scss']
})
export class AvaliabilityOperatorComponent implements OnInit, OnChanges {
  public _availability: AvailabilityEntity[] = [];
  @Input() avaliability: AvailabilityEntity[] = [];
  @Input() canEdit = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    this._availability = this.avaliability;
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  delete(elem: any) {
    this.onDelete.emit(elem);
  }

}
